import { initialStateOptions } from '@/utils/pagination-utils';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  searchText: null,
  onlyPadrao: false,
  listOptions: initialStateOptions('mensagem'),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
